function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M126,105 L120,105 L120,89 C120,83.4771525 115.522847,79 110,79 L108,79 L108,73 L111,73 C119.284271,73 126,79.7157288 126,88 L126,105 Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M125.5,104.5 L125.5,88 C125.5,79.9918711 119.008129,73.5 111,73.5 L108.5,73.5 L108.5,78.5 L110,78.5 C115.79899,78.5 120.5,83.2010101 120.5,89 L120.5,104.5 L125.5,104.5 Z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 95,
  height: 13,
  x: 7,
  y: 92
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 94,
  height: 12,
  x: 7.5,
  y: 92.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 109,
  height: 95,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 108,
  height: 94,
  x: 0.5,
  y: 0.5,
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 10)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 12
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 12.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 24
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 24.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 36
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 36.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 48
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 48.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 60
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 60.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 66
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 66.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 6
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 18
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 30
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 30.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 42
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 42.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 54
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 54.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 72
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 72.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 10)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 9,
  height: 3,
  y: 12
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 8,
  height: 2,
  x: 0.5,
  y: 12.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 9,
  height: 3,
  y: 24
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 8,
  height: 2,
  x: 0.5,
  y: 24.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 36
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 36.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 48
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 48.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 60
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 60.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 66
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 66.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 6
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 9,
  height: 3,
  y: 18
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 8,
  height: 2,
  x: 0.5,
  y: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 30
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 30.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 42
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 42.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 54
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 54.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 72
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 72.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 10)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 8,
  height: 3,
  x: 10,
  y: 12
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 7,
  height: 2,
  x: 10.5,
  y: 12.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 8,
  height: 3,
  x: 10,
  y: 24
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 7,
  height: 2,
  x: 10.5,
  y: 24.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 36
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 36.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 48
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 48.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 60
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 60.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 66
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 66.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 6
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 8,
  height: 3,
  x: 10,
  y: 18
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 7,
  height: 2,
  x: 10.5,
  y: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 30
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 30.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 42
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 42.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 54
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 54.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 72
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 72.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(81 10)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 12
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 12.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 24
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 24.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 36
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 36.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 48
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 48.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 60
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 60.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 66
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 66.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 6
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 18
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 30
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 30.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 42
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 42.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 54
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 54.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 18,
  height: 3,
  y: 72
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 17,
  height: 2,
  x: 0.5,
  y: 72.5
})), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 17,
  height: 13,
  x: 46,
  y: 23,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 16,
  height: 12,
  x: 46.5,
  y: 23.5,
  rx: 3
}));

function SvgRoomHvacOutdoorUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 105,
    viewBox: "0 0 126 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomHvacOutdoorUnit);
export default __webpack_public_path__ + "static/media/RoomHvacOutdoorUnit.bd8a0092.svg";
export { ForwardRef as ReactComponent };